var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.366 9.725c-.478.478-.504 1.374.017 1.894.512.512 1.408.495 1.895.009l3.721-3.72 3.713 3.72c.513.495 1.383.503 1.895-.017.521-.52.521-1.391.017-1.895L7.911 6.004l3.713-3.72c.504-.504.504-1.374-.017-1.895-.512-.52-1.382-.512-1.895-.017L6 4.092 2.278.373C1.79-.114.895-.13.383.39c-.52.512-.495 1.408-.017 1.886l3.721 3.73z"
  })));
};
export default SvgTimes;